import { Typography } from '@mui/material'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Plus from 'mdi-material-ui/Plus'
import { useCallback, useEffect, useState } from 'react'
import { apiService } from '../../api/axiosClient'
import Page from '../../components/Page'
import PageHeader from '../../components/page-header'
import Spinner from '../../components/spinner'
import BoxWrapper from '../../styles/BoxWrapper'
import DialogEvent from '../../views/event/DialogEvent'
import EventWrapper from '../../views/event/EventWrapper'

const EventList = () => {
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [show, setShow] = useState(false)

  const loadEvents = useCallback(() => {
    const fetchData = async () => {
      const response = await apiService.get('/events')
      const payload = response.data;
            
      setItems(payload.list)
      setLoading(false)
    }

    fetchData().catch(e => console.error(e));
  }, []);

  useEffect(loadEvents, []);

  return (
    loading ?
    <Spinner/> :
    <Page title="Event">
      <Grid container spacing={6}>
        <PageHeader
          title={
            <Typography variant='h5' color='#666CFF'>
              이벤트 관리
            </Typography>
          }
          subtitle={
            <Typography variant='body2'>
              이벤트를 사용자에게 보여줘서 사용자가 지속적인 사이트 유입을 유도하세요
            </Typography>
          }
        />
        <BoxWrapper>
          <Button variant='contained' startIcon={<Plus />} onClick={() => {setShow(true)}} >등록</Button>
        </BoxWrapper>
        <DialogEvent show={show} setShow={setShow} loadEvents={loadEvents}/>
        <Grid item xs={12}>
          {items.length > 0 ? (
            <EventWrapper items={items} setItems={setItems} />
          ) : (
            <Alert severity='warning'>이벤트 데이타가 없습니다 — <strong>새로 만들어보세요</strong></Alert>
          )}
        </Grid>
      </Grid>
    </Page>
  )
}

export default EventList